// Parentum PDF Branding Assets and Utilities

export var PDF_DISCLAIMER = "Important Legal Disclaimer: This PDF is provided by Parentum solely as an organizational aid and general informational resource. It is not legal advice, is not a substitute for an attorney. This PDF is not intended to be a legal document. The inclusion of branding, formatting, and logo elements does not comply with the rules of civil procedure in most jurisdictions, and a judge or judicial officer has full discretion to accept, reject, strike, or disregard this document on that basis or for any other procedural, evidentiary, or jurisdictional reason. This document does not constitute legal advice and is not a substitute for representation by a licensed attorney. It is not guaranteed to be admissible, accepted, filed, considered, or relied upon by any court, judicial officer, attorney, mediator, custody evaluator, agency, or other decision-maker. Courts and other authorities may reject or disregard this document for any reason, including but not limited to evidentiary issues, procedural defects, formatting deficiencies, authentication problems, lack of foundation, hearsay concerns, violations of local rules, timeliness issues, or other legal deficiencies. The user alone is solely responsible for determining whether and how this document may be used, submitted, disclosed, or relied upon, and for ensuring full compliance with all applicable laws, rules of evidence, procedural requirements, court orders, and filing standards. The user is solely responsible for making any requests for business records affidavits certifying the authenticity of the regularly kept business record, which can be found in the users profile navigational tab. Parentum assumes no responsibility or liability for the user's submission, use, non-use, rejection, exclusion, or treatment of this PDF in any matter.";

var headerImgData = null;
var footerLogoData = null;

// 0.3 inch margin from top and bottom = ~7.6mm
var TOP_MARGIN = 7.6;
var BOTTOM_MARGIN = 7.6;

function loadImage(src) {
  return new Promise(function (resolve) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = function () { resolve(null); };
    img.src = src;
  });
}

export async function ensureImagesLoaded() {
  if (!headerImgData) headerImgData = await loadImage('/pdf-header.png');
  if (!footerLogoData) footerLogoData = await loadImage('/pdf-footer-logo.png');
}

export function addPdfHeader(pdf) {
  var pw = pdf.internal.pageSize.getWidth();
  if (headerImgData) {
    var fullW = pw - 30;
    var imgW = fullW * 0.20;
    var imgH = imgW / 14.68;
    var x = (pw - imgW) / 2;
    pdf.addImage(headerImgData, 'PNG', x, TOP_MARGIN, imgW, imgH);
    var lineY = TOP_MARGIN + imgH + 2;
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.3);
    pdf.line(15, lineY, pw - 15, lineY);
    return lineY + 5;
  } else {
    pdf.setFontSize(12);
    pdf.setTextColor(0, 0, 0);
    pdf.text('PARENTUM', pw / 2, TOP_MARGIN + 5, { align: 'center' });
    var lineY2 = TOP_MARGIN + 9;
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.3);
    pdf.line(15, lineY2, pw - 15, lineY2);
    return lineY2 + 5;
  }
}

export function addPdfFooterToAllPages(pdf) {
  var totalPages = pdf.internal.getNumberOfPages();
  var pw = pdf.internal.pageSize.getWidth();
  var ph = pdf.internal.pageSize.getHeight();
  var footerBottom = ph - BOTTOM_MARGIN;

  for (var i = 1; i <= totalPages; i++) {
    pdf.setPage(i);

    // Separator line
    var footerY = footerBottom - 14;
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.3);
    pdf.line(15, footerY, pw - 15, footerY);

    // Disclaimer text — above page number
    pdf.setFontSize(4.2);
    pdf.setTextColor(0, 0, 0);
    var lines = pdf.splitTextToSize(PDF_DISCLAIMER, pw - 30);
    pdf.text(lines, 15, footerY + 2.5);

    // Page number — at the bottom
    pdf.setFontSize(7);
    pdf.setTextColor(0, 0, 0);
    pdf.text('Page ' + i + ' of ' + totalPages, pw / 2, footerBottom, { align: 'center' });

    // Footer logo — bottom left corner
    if (footerLogoData) {
      var logoSize = 5;
      pdf.addImage(footerLogoData, 'PNG', 5, footerBottom - logoSize, logoSize, logoSize);
    }
  }
}
